import { FC, useCallback, useState } from 'react'
import { Modal, Button, Typography } from 'antd'
import { useNavigate } from 'react-router-dom'
import { useAppSelector } from 'store'

const { Paragraph } = Typography

interface Props {
  open: boolean
  onClose: () => void
}

/**
 * แจ้งเตือนเมื่อบัญชียังไม่มีอีเมล — การลงทะเบียนอบรมต้องใช้อีเมลรับลิงก์ประชุม
 */
export const NeedEmailModal: FC<Props> = ({ open, onClose }) => {
  const navigate = useNavigate()

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title="บัญชีของคุณยังไม่มีอีเมล"
      footer={[
        <Button key="cancel" onClick={onClose}>
          ปิด
        </Button>,
        <Button
          key="go"
          type="primary"
          onClick={() => {
            onClose()
            navigate('/profiles/setting-my-profile')
          }}
        >
          ไปเพิ่มอีเมล
        </Button>,
      ]}
    >
      <Paragraph>
        การลงทะเบียนอบรมต้องใช้อีเมล เพราะระบบจะส่ง<strong>ลิงก์เข้าร่วมประชุม</strong>และ
        <strong>เอกสารประกอบ</strong>ไปให้ทางอีเมล
      </Paragraph>
      <Paragraph type="secondary" style={{ marginBottom: 0 }}>
        กรุณาเพิ่มอีเมลในโปรไฟล์ก่อน แล้วกลับมาจองรอบอบรมอีกครั้ง
      </Paragraph>
    </Modal>
  )
}

/**
 * hook สำหรับด่านตรวจอีเมลก่อนจอง
 *
 * อ่านอีเมลจาก redux (profile โหลดไว้แล้วตอนล็อกอิน) — ไม่ต้องยิง API เพิ่ม
 * นี่เป็นแค่ UX guard: ด่านจริงอยู่ฝั่ง server (400 EMAIL_REQUIRED)
 * ถ้าหลุดมาถึง API ให้เรียก openNeedEmail() จาก error handler ได้เหมือนกัน
 */
export const useRequireEmail = () => {
  const [needEmailOpen, setNeedEmailOpen] = useState(false)
  const email = useAppSelector(state => state.auth.profile?.user?.email)

  /** คืน true = มีอีเมลแล้ว ไปต่อได้ / false = เปิด modal ให้ไปใส่อีเมล */
  const ensureEmail = useCallback((): boolean => {
    if (email && email.trim()) return true
    setNeedEmailOpen(true)

    return false
  }, [email])

  return {
    email,
    hasEmail: !!email?.trim(),
    ensureEmail,
    needEmailOpen,
    openNeedEmail: () => setNeedEmailOpen(true),
    closeNeedEmail: () => setNeedEmailOpen(false),
  }
}

export default NeedEmailModal
